// Open status for an emailed note (Dave 2026-10-26). The notes APIs add
// email_sent_at / email_opened_at / email_open_count / email_last_opened_at
// when the note pairs with a tracked email (see server/lib/noteEmailTracking.js).
// Nothing renders for notes that aren't tracked emails.
//
// Opens come from a tracking pixel, so they're a strong hint, not proof:
// some mail apps block images (shows "Not opened yet" even if read) and
// some preload them (counted once, not repeatedly).

function fmt(ts) {
  if (!ts) return '';
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('en-CA', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
}

export default function EmailOpenBadge({ note }) {
  if (!note?.email_sent_at) return null;
  const opened = !!note.email_opened_at;
  const count = Number(note.email_open_count) || (opened ? 1 : 0);
  const style = {
    display: 'inline-block', fontSize: 11, fontWeight: 600, padding: '1px 8px', borderRadius: 999,
    background: opened ? 'rgba(13,148,136,.12)' : 'rgba(100,116,139,.12)',
    color: opened ? 'var(--color-good, #0d9488)' : 'var(--color-text-dim)',
  };
  const title = opened
    ? `First opened ${fmt(note.email_opened_at)}${note.email_last_opened_at ? `, last opened ${fmt(note.email_last_opened_at)}` : ''}. Opens are tracked with an image, so they're a strong hint rather than proof.`
    : 'No open recorded yet. Some mail apps block the tracking image, so it may have been read anyway.';
  return (
    <span style={style} title={title}>
      {opened
        ? `✓ Opened${count > 1 ? ` ${count}×` : ''} · ${fmt(note.email_last_opened_at || note.email_opened_at)}`
        : 'Not opened yet'}
    </span>
  );
}
